import React from 'react';
import { GridJustification } from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import clsx from 'clsx';
import { BasicGrid } from '../layout';

interface Props {
  containerClassName?: string;
  itemClassName?: string;
  justify?: GridJustification;
  alignItems?: AlignSetting;
  noPadding?: boolean;
  baseXs?: number;
  baseSm?: number;
  baseMd?: number;
  baseLg?: number;
}

const ButtonGridHeight = '69px';
const useStyles = makeStyles((theme) =>
  createStyles({
    buttonGrid: {
      backgroundColor: theme.palette.background.default,
      [theme.breakpoints.down('xs')]: {
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '8px',
        maxHeight: 'calc(100% - 100px)',
        minHeight: ButtonGridHeight,
        zIndex: 1000,
      },
    },
  }),
);

const ButtonGrid: React.FC<Props> = ({
  children,
  containerClassName,
  itemClassName,
  justify,
  alignItems,
  noPadding,
  baseXs,
  baseSm,
  baseMd,
  baseLg,
}) => {
  const classes = useStyles();
  return (
    <BasicGrid
      containerClassName={clsx(classes.buttonGrid, containerClassName)}
      itemClassName={itemClassName}
      justify={justify}
      alignItems={alignItems}
      noPadding={noPadding}
      baseXs={baseXs}
      baseSm={baseSm}
      baseMd={baseMd}
      baseLg={baseLg}
    >
      {children}
    </BasicGrid>
  );
};

export { ButtonGridHeight };
export default ButtonGrid;
